module.exports = __webpack_public_path__ + "static/media/dm4.e10399fc.svg";